import { BuilderConfig } from '@/types/builder';

import RoomStayBlogCustomerHero2, { CustomerCaseHeroProps } from './roomstay-blog-customer-case-hero-2';

export const RoomStayBlogCustomerCaseBuilderConfig = {
    name: 'Customer Hero Case 2',
    inputs: [
        {
            name: 'tags',
            type: 'array',
            subFields: [
                {
                    name: 'tag',
                    type: 'string',
                },
            ],
        },
        {
            name: 'subTitle',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'title',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'graphic',
            type: 'file',
        },
        {
            name: 'backgroundImage',
            type: 'file',
        },
    ],
};

const builderConfig: BuilderConfig<CustomerCaseHeroProps> = {
    component: RoomStayBlogCustomerHero2,
    config: RoomStayBlogCustomerCaseBuilderConfig,
};

export default builderConfig;
